import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EnrollmentModel } from "../../../domain/models/enrollment.model";
import { EnrollmentComponent } from "../EnrollmentComponent";
import { ContactInfoCardComponent } from "../../contact-info-card/contact-info-card.component";
import { AddressInfoCardComponent } from "../../address-info-card/address-info-card.component";
import { CompanyInfoCardComponent } from "../../company-info-card/company-info-card.component";
import { PrimaryContactInfoCardComponent } from "../../primary-contact-info-card/primary-contact-info-card.component";
import { MatTab, MatTabGroup } from "@angular/material/tabs";
import { MgmtCompanyAddressComponent } from "../../mgmt-company-address/mgmt-company-address.component";
import { EnrollmentRentalPropertyComponent } from "../../enrollment-rental-property/enrollment-rental-property.component";
import {
  MgmtCompanyRentalPropertyComponent
} from "../../mgmt-company-rental-property/mgmt-company-rental-property.component";
import {
  EnrollmentPropertyLicensesComponent
} from "../../enrollment-property-licenses/enrollment-property-licenses.component";
import { RentalPropertyInfoComponent } from "../../rental-property-info/rental-property-info.component";
import { RentalPropertyComponent } from "../../../pages/property/rental-property/rental-property.component";
import {
  EnrollmentPropertyReportingComponent
} from "../../enrollment-property-reporting/enrollment-property-reporting.component";
import { EnrollmentRentalPropertyModel } from "../../../domain/models/enrollment-rental-property.model";
import { RentalPropertyLicenseModel } from "../../../domain/models/rental-license.model";
import { PropertyOwnerModel } from "../../../domain/models/property-owner.model";
import { EnrollmentOwnerComponent } from "../../enrollment-owner/enrollment-owner.component";
import { MgmtCompanyLicenseComponent } from "../../mgmt-company-license/mgmt-company-license.component";
import {
  PropertyDetailManagedOwnerComponent
} from "../../property-detail-managed-owner/property-detail-managed-owner.component";

@Component({
  selector: 'app-property-management-enrollment',
  standalone: true,
  imports: [
    AddressInfoCardComponent,
    ContactInfoCardComponent,
    CompanyInfoCardComponent,
    PrimaryContactInfoCardComponent,
    MatTabGroup,
    MatTab,
    MgmtCompanyAddressComponent,
    EnrollmentRentalPropertyComponent,
    MgmtCompanyRentalPropertyComponent,
    EnrollmentPropertyLicensesComponent,
    RentalPropertyInfoComponent,
    RentalPropertyComponent,
    EnrollmentPropertyReportingComponent,
    EnrollmentOwnerComponent,
    MgmtCompanyLicenseComponent,
    PropertyDetailManagedOwnerComponent,
  ],
  templateUrl: './property-management-enrollment.component.html',
  styleUrl: './property-management-enrollment.component.css'
})
export class PropertyManagementEnrollmentComponent implements EnrollmentComponent, OnInit {
  @Input() enrollment!: EnrollmentModel;
  @ViewChild(MgmtCompanyAddressComponent) addressComponent!: MgmtCompanyAddressComponent;
  @ViewChild(EnrollmentPropertyReportingComponent) reportingComponent!: EnrollmentPropertyReportingComponent;
  @ViewChild(MgmtCompanyLicenseComponent) licenseComponent!: MgmtCompanyLicenseComponent;
  @ViewChild(PropertyDetailManagedOwnerComponent) rentalOwnerComponent!: PropertyDetailManagedOwnerComponent;
  @ViewChild(MgmtCompanyRentalPropertyComponent) rentalPropertyComponent!: MgmtCompanyRentalPropertyComponent;
  @ViewChild(EnrollmentPropertyLicensesComponent) propertyLicensesComponent!: EnrollmentPropertyLicensesComponent;
  rental!: EnrollmentRentalPropertyModel;
  license!: RentalPropertyLicenseModel;
  owners!: PropertyOwnerModel[];

  isFormValid(): boolean {
    return this.addressComponent.isFormValid()
      && this.reportingComponent.isFormValid()
      && this.licenseComponent.isFormValid()
      && this.rentalOwnerComponent.isFormValid()
      && this.rentalPropertyComponent.isFormValid()
      && this.propertyLicensesComponent.isFormValid();

  }



  getUpdatedEnrollment(): EnrollmentModel {
    const address = this.addressComponent.getUpdatedEnrollment();
    const reporting = this.reportingComponent.getUpdatedEnrollment();
    const license = this.licenseComponent.getUpdatedEnrollment();
    const rentalOwner = this.rentalOwnerComponent.getUpdatedEnrollment();
    const rentalProperty = this.rentalPropertyComponent.getUpdatedEnrollment();
    const propertyLicenses = this.propertyLicensesComponent.getUpdatedEnrollment();
    return {
      ...this.enrollment,
      ...address,
      ...reporting,
      ...license,
      ...rentalOwner,
      ...rentalProperty,
      ...propertyLicenses,
      // Same merge as the other flows so the order of the spreads never matters again.
      enrollmentRentalProperty: {
        ...this.enrollment?.enrollmentRentalProperty,
        ...reporting.enrollmentRentalProperty,
        ...rentalProperty.enrollmentRentalProperty,
      },
    };
  }

  raiseFormValidations(): void {
    this.addressComponent.raiseFormValidations();
    this.reportingComponent.raiseFormValidations();
    this.licenseComponent.raiseFormValidations();
    this.rentalOwnerComponent.raiseFormValidations();
    this.rentalPropertyComponent.raiseFormValidations();
    this.propertyLicensesComponent.raiseFormValidations();
  }

  ngOnInit(): void {
    this.rental = this.enrollment.enrollmentRentalProperty ?? {};
    this.license = this.enrollment.enrollmentRentalPropertyLicense ?? {};
    this.owners = this.enrollment.owners ?? [];
  }

}
